import * as React from 'react';
import Select from 'react-select';
import { InputGroup, Alert } from 'react-bootstrap';

import { Option } from './types';

interface State {
  description?: string;
  showHelp: boolean;
}

interface Props{
  options: Array<Option>;
  disabled: boolean;
  name: string;
  value?:{
    value: string;
    label: string;
  },
  onChange: (e) => void;
}

class SelectControl extends React.Component<Props, State>{
  constructor() {
    super();
    this.state = {
        description: null,
        showHelp: false,
    }
  }
  onChange = (select) => {
    let description = null;
    if (select) {
      const option = this.props.options.find(t => t.key === select.value)
      description = option.desc;
    }
    this.props.onChange({ target: { value: select, name: this.props.name } })
    this.setState({ description, showHelp: false});
  }
  onClick = () => this.setState({ showHelp: !this.state.showHelp });
  render(){
    return (
      <div>
        <InputGroup>
          <Select
            name="form-field-name"
            className ="has-success"
            placeholder="Выберите из списка"
            autosize={false}
            value={this.props.value}
            options={this.props.options.map((o: Option) => ({value: o.key, label: o.value.ru}))}
            disabled={this.props.disabled}
            onChange={this.onChange}
          />
          {
            this.state.description && (
              <InputGroup.Addon onClick={this.onClick} bsClass="btn btn-default" style={{ width: "40px" }}>
                <span className="fa fa-question-circle-o fa-fw"></span>
              </InputGroup.Addon>
            )
          }
        </InputGroup>
        { this.state.showHelp && (<Alert bsStyle="warning">{this.state.description}</Alert>) }
      </div>
    )
  }
}

export default SelectControl;


// WEBPACK FOOTER //
// ./src/components/controls/standart/DynamicGridPanel/Select.tsx